import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ModalButtons,
  Typography,
  Button,
} from 'pvs-design-system';

interface DuplicateToolModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DuplicateToolModal: React.FC<DuplicateToolModalProps> = ({
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();
  const handleCancel = () => {
    navigate('/ltimanagement/tools');
  };
  return (
    <Modal onClose={onClose} open={isOpen} closeModalOnBackdropClick>
      <ModalHeader
        title="Tool Not Added - Duplicate Found"
        onClose={onClose}
        description=""
      />
      <ModalContent>
        <Typography variant="p-sm">
          The LTI 1.3 tool has not been added because it appears to be a
          duplicate. Please revise the tool details to include a unique Tool
          Name and Tool Hostname.
        </Typography>
      </ModalContent>
      <ModalFooter>
        <ModalButtons>
          <Button id="modalCancel" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button id="modalRevise" onClick={onClose}>
            Revise Tool Details
          </Button>
        </ModalButtons>
      </ModalFooter>
    </Modal>
  );
};

export default DuplicateToolModal;
